import React, { useState } from "react";
import { Formik, Form } from "formik";
import { Basic } from "./ModifiedSearch/Basic";
import { Advanced } from "./ModifiedSearch/Advanced";
import { Parameter } from "./ModifiedSearch/Parameter";
import { Additional } from "./ModifiedSearch/Additional";
import axios from "axios";
import { toast } from 'react-toastify';
import { NODE_API_URL,BASE_URL } from "../../../env_config";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";
import { FaSearch } from "react-icons/fa";

function ModifiedSearchOffcanvas(props) {
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const history = useHistory()
    const [errorMsg,setErrorMsg] = useState('');

    const disableLoading = () => {
        setIsSubmitting(false)
    };
        const showSearchToast = (type, message) => {
            toast[type](message, {
                containerId: "search-toast",
                autoClose: 6000
            });
        };

        const validateFilters = (values) => {
        const shapeSelected = Array.isArray(values.Shape) && values.Shape.length > 0;

        const caratManual =
            values.Min_Carat || values.Max_Carat;

        const caratRange = Object.keys(values).some(
            (k) => k.startsWith("CaratRange") && values[k]
        );

        const caratSelected = caratManual || caratRange;

        const anyFilterSelected = Object.keys(values).some(
            (k) =>
            values[k] !== "" &&
            values[k] !== null &&
            !(Array.isArray(values[k]) && values[k].length === 0)
        );

        if (!anyFilterSelected) {
            return "Please select at least one filter";
        }

        if (!shapeSelected && !caratSelected) {
            return "Please Select Shape and Carat to continue with search.";
        }

        if (!shapeSelected) {
            return "Please Select Shape to continue with search.";
        }

        if (!caratSelected) {
            return "Please Select Carat to continue with search.";
        }

        return null;
    };
    
    function handleData(values,oldvalues) {
        // enableLoading();
        props.setLoader(true)
        const fancy = oldvalues.diamond_type === "N"?Cookies.get("fancy")?1:0:Cookies.get("fancybasic")?1:0
        const id = localStorage.getItem("C_id");
        let len = Object.keys(values).length;
        const temp = values;
        let data = "";
        for (let key in temp) {
            len--;
            let arr = temp[key];
            if (len) {
                if (Array.isArray(arr)) {
                    let str = "";
                    str += "'" + arr.join("','") + "'";
                    data += `{"FilterName": "${key}","FilterValue":"${str}" }, `;
                } else {
                    data += `{"FilterName": "${key}","FilterValue": "'${temp[key]}'"},`;
                }
            } else {
                if (Array.isArray(arr)) {
                    let str = "";
                    str += "'" + arr.join("','") + "'";
                    data += `{"FilterName": "${key}","FilterValue":"${str}" } `;
                } else {
                    data += `{"FilterName": "${key}","FilterValue": "'${temp[key]}'"}`;
                }
            }
        }
        const finalData = `{ "JsonData":  [${data}] , "CustomerId": "${props.userinfo.id}", "ConsumerId":${ id === "" ? "-1" : id }, "WLDiamondType": "${oldvalues.diamond_type}" ,"page":1, "conversionrate":"${props.conversionrate}","curr":"${props.symbolname}","fancy":"${fancy}","loginLogId":${Cookies.get("_LogId")} }`;
        props.setPageNumber(1)
        if(oldvalues.diamond_type === "N"){
            localStorage.setItem("modifysearch",JSON.stringify(values))
        }
        else{
            localStorage.setItem("modifysearchlab",JSON.stringify(values))
        }
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/searchDiamond`,
            headers: {
                "Content-Type": "application/json",
                 "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            },
            data: finalData,
        })
        .then(function(res) {
             if(!res.data.data.length){
                showSearchToast(
                    "error",
                    res?.data?.message || "0 Stones found please try again"
                );
                setErrorMsg(res?.data?.message)
                props.setLoader(false)
                disableLoading();
                return
            }
            props.setSwipeableDrawer('right', false)    
            props.setStockAPI(res.data.data)
            disableLoading();
            history.push({
                pathname: `/search-result/${oldvalues.diamond_type}`,
                state: {
                    searchresult:res.data.data,
                    oldvalues:oldvalues,
                    page:1
                },
                });
                props.setSortObj({id:"",sortorder:""})
                props.setLoader(false)
                props.setUpdateCount(!props.updatecount)
        })
        .
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
    }
    return (
        <>
            <div style={{ width: "380px" }}>
                <div className="row m-0 mt-5">
                    <div className="col-12 border-bottom d-flex justify-content-between align-items-center sticky-top bg-white">
                        <p className="font-size-h3 ml-5 font-weight-bold">
                            {props.language.MODIFY_SEARCH_EDIT_FILTER}
                        </p>
                    </div>
                    
                        <Formik
                            enableReinitialize={true}
                            initialValues={{}}
                            onSubmit={async (values, { setSubmitting }) => {
                                // enableLoading();
                                let oldvalues =values
                                Object.keys(values).forEach((key) => {
                                    if (
                                        values[key] === "" ||
                                        values[key] === null ||
                                        values[key].length === 0
                                    ) {
                                        delete values[key];
                                    }
                                });
                                const error = validateFilters(values);

                                if (error) {
                                    setErrorMsg(error);
                                    showSearchToast("error", error);
                                    disableLoading();
                                    return;
                                }

                                setTimeout(() => {
                                    handleData(values, oldvalues);
                                }, 1000);
                            }}
                        >
                            {(formik, handleSubmit) => (
                                <>
                                    <Form className="w-100 globleFilter searchDiamondBox ">
                                        <div className={`col-12 border-bottom d-flex justify-content-between align-items-center mt-5 modified-search-canvas ${props.diamond_type === "L"? "labTab" :"natTab" }`}>
                                            <div
                                                className="custom-scrollbar w-100"
                                                style={{
                                                    position: "relative",
                                                }}
                                            >
                                                <div className="mb-8">
                                                    <Basic errorMsg={errorMsg} setErrorMsg={setErrorMsg} language={props.language} diamond_type={props.diamond_type} formik={formik} oldvalues={props.oldvalues}/>
                                                </div>
                                               
                                                <div className="mb-8">
                                                    <Advanced language={props.language} formik={formik}/>
                                                </div>
                                                <div className="mb-8">
                                                    <Parameter language={props.language} formik={formik}/>
                                                </div>
                                                <div className="mb-8">
                                                    <Additional language={props.language} diamond_type={props.diamond_type} formik={formik}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`col-12 my-2 text-right ${props.diamond_type === "L"? "labTab" : "natTab" } position-sticky bottom-0 bg-white p-3`} style={{zIndex:1024}}>
                                            <button className="btn btn-text-danger btn-hover-light-danger font-weight-bold px-10" onClick={() =>   props.diamond_type === "L"?localStorage.removeItem("modifysearchlab"):localStorage.removeItem("modifysearch")}>
                                                {props.diamond_type === "L"?<a className="text-danger" href='/labsearchdiamond/white'> RESET</a>:<a className="text-danger"  href='/searchdiamond/white'> RESET</a>}
                                            </button>
                                            <button
                                                type="submit"
                                                className={`btn btn-primary px-10 font-weight-bold  ml-2 ${isSubmitting ? "cursor-na" : ""}`}
                                                disabled={isSubmitting}
                                                onClick={handleSubmit}
                                            >
                                                 <FaSearch className="mr-2 font-size-h5" />
                                                {isSubmitting
                                                    ? "Please wait..."
                                                    : props.language.MODIFY_SEARCH_EDIT_SEARCH}
                                                
                                            </button>
                                        </div>
                                    </Form>
                                </>
                            )}
                        </Formik>
                    
                </div>
            </div>
        </>
    );
}                                   

export default ModifiedSearchOffcanvas;
